import { Theme, alpha } from '@mui/material/styles';
import type { Post, PostTheme } from './types';

/** The app's own look, in light or dark mode, for posts without a theme of their own. */
export const defaultPostTheme = (theme: Theme): PostTheme => ({
  surface: theme.palette.background.paper,
  text: theme.palette.text.primary,
  textMuted: theme.palette.text.secondary,
  accent: theme.palette.primary.main,
  onAccent: theme.palette.primary.contrastText,
  glow: alpha(theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.24 : 0.16)
});

export const postTheme = (post: Post, theme: Theme): PostTheme => post.theme ?? defaultPostTheme(theme);
